const SupportedLanguages = [
  { id: 'en', title: 'English', isDefault: true },
  { id: 'nb', title: 'Norwegian' },
];

export default SupportedLanguages;
